import { promiseAction } from 'utils/store';

export const DICTIONARIES_ACTION_TYPES = {
  LOAD_PLAIN_BUSINESS_LINES: 'dictionaries/LOAD_PLAIN_BUSINESS_LINES',
  LOAD_PLAIN_INTERESTS: 'dictionaries/LOAD_PLAIN_INTERESTS',
  LOAD_PLAIN_LANGUAGES_SPOKEN: 'languages/LOAD_PLAIN_LANGUAGES_SPOKEN',
  LOAD_COUNTRIES: 'dictionaries/LOAD_COUNTRIES',
  LOAD_CITIES: 'dictionaries/LOAD_CITIES',
  LOAD_BUSINESS_LINES: 'dictionaries/LOAD_BUSINESS_LINES',
  CREATE_BUSINESS_LINE: 'dictionaries/CREATE_BUSINESS_LINE',
  EDIT_BUSINESS_LINE: 'dictionaries/EDIT_BUSINESS_LINE',
  DELETE_BUSINESS_LINE: 'dictionaries/DELETE_BUSINESS_LINE',
  VERIFY_BUSINESS_LINE: 'dictionaries/VERIFY_BUSINESS_LINE',
  LOAD_INTERESTS: 'dictionaries/LOAD_INTERESTS',
  CREATE_INTEREST: 'dictionaries/CREATE_INTEREST',
  EDIT_INTEREST: 'dictionaries/EDIT_INTEREST',
  DELETE_INTEREST: 'dictionaries/DELETE_INTEREST',
  VERIFY_INTEREST: 'dictionaries/VERIFY_INTEREST',
  LOAD_LANGUAGES_SPOKEN: 'dictionaries/LOAD_LANGUAGES_SPOKEN',
  CREATE_LANGUAGE_SPOKEN: 'dictionaries/CREATE_LANGUAGE_SPOKEN',
  EDIT_LANGUAGE_SPOKEN: 'dictionaries/EDIT_LANGUAGE_SPOKEN',
  DELETE_LANGUAGE_SPOKEN: 'dictionaries/DELETE_LANGUAGE_SPOKEN',
  VERIFY_LANGUAGE_SPOKEN: 'dictionaries/VERIFY_LANGUAGE_SPOKEN',
};

export const loadPlainBusinessLines = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_BUSINESS_LINES)
export const loadPlainInterests = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_INTERESTS)
export const loadPlainLanguagesSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_PLAIN_LANGUAGES_SPOKEN)

export const loadCountries = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_COUNTRIES)
export const loadCities = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_CITIES)

export const loadBusinessLines = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_BUSINESS_LINES)
export const createBusinessLine = promiseAction(DICTIONARIES_ACTION_TYPES.CREATE_BUSINESS_LINE)
export const editBusinessLine = promiseAction(DICTIONARIES_ACTION_TYPES.EDIT_BUSINESS_LINE)
export const deleteBusinessLine = promiseAction(DICTIONARIES_ACTION_TYPES.DELETE_BUSINESS_LINE)
export const verifyBusinessLine = promiseAction(DICTIONARIES_ACTION_TYPES.VERIFY_BUSINESS_LINE)

export const loadInterests = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_INTERESTS)
export const createInterest = promiseAction(DICTIONARIES_ACTION_TYPES.CREATE_INTEREST)
export const editInterest = promiseAction(DICTIONARIES_ACTION_TYPES.EDIT_INTEREST)
export const deleteInterest = promiseAction(DICTIONARIES_ACTION_TYPES.DELETE_INTEREST)
export const verifyInterest = promiseAction(DICTIONARIES_ACTION_TYPES.VERIFY_INTEREST)

export const loadLanguagesSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.LOAD_LANGUAGES_SPOKEN)
export const createLanguageSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.CREATE_LANGUAGE_SPOKEN)
export const editLanguageSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.EDIT_LANGUAGE_SPOKEN)
export const deleteLanguageSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.DELETE_LANGUAGE_SPOKEN)
export const verifyLanguageSpoken = promiseAction(DICTIONARIES_ACTION_TYPES.VERIFY_LANGUAGE_SPOKEN)
